import FlexRow from "./FlexRow";
import { range } from "lodash";
import FlexColumn from "./FlexColumn";
import React, { useEffect, useState } from "react";
import { useService } from "student-front-commons/src/hooks";
import { getModulesByCourse, setModuleScore } from "student-front-commons/src/services/moduleService";
import Styled from "styled-components";
import { mergeEntities } from "student-front-commons/src/actions/entity";
import { useDispatch } from "react-redux";

const RateSymbol = Styled.button`
    outline: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    font-size: 11px;
    line-height: 11px;
    border-radius: 4px;
    color: ${(props) => (props.isSelected ? "#fff" : "#4e4e4e")};
    font-weight: 600;
    border: 1px solid ${(props) => (props.isSelected ? `${props.variant}b3` : "rgba(0,0,0,0.3)")};
    background-color: ${(props) => (props.isSelected ? `${props.variant}b3` : "white")};
    opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
    transition: all ease-in-out 150ms;
    
    &:hover {
        transform: ${(props) => (props.isDisabled ? "none" : "scale(1.05)")};
        color: #fff;
        background-color: ${(props) => (!props.isDisabled ? `${props.variant}b3` : "white")};
        border: 1px solid ${(props) => (!props.isDisabled ? `${props.variant}b3` : "rgba(0,0,0,0.3)")};
      }
`;

export default function ModuleRating({ moduleId, courseId }) {
  const dispatch = useDispatch();

  const [rated, setRated] = useState(false);
  const [feelingCapableScore, setFeelingCapableScore] = useState(0);
  const [contentSatisfactionScore, setContentSatisfactionScore] = useState(0);

  const [, fetchModules] = useService(getModulesByCourse, {
    autoStart: false,
    onData: (modules) => {
      dispatch(mergeEntities(modules.entities));
    },
  });

  const [isSubmitting, submit] = useService(setModuleScore, {
    autoStart: false,
    onData: () => {
      setRated(true);
      fetchModules({ id: sessionStorage.getItem("id"), course: courseId });
    },
  });

  useEffect(() => {
    if (moduleId && courseId && feelingCapableScore && contentSatisfactionScore) {
      submit({
        id: sessionStorage.getItem("id"),
        course: courseId,
        module: moduleId,
        feelingCapableScore,
        contentSatisfactionScore,
      });
    }
  }, [moduleId, courseId, feelingCapableScore, contentSatisfactionScore]);

  if (rated) {
    return null;
  }
  return (
    <FlexColumn
      flex={1}
      backgroundColor="#ffffffb3"
      margin="0px 8px"
      padding={12}
      border="1px solid rgba(0, 0, 0, 0.2)"
      borderBottomLeftRadius={4}
      borderBottomRightRadius={4}
      rowGap={4}
    >
      <FlexRow alignItems="center" justifyContent="space-between">
        <span style={{ fontSize: 12, color: "#4e4e4e", fontWeight: 600 }}>
          Me sinto capaz de me apresentar e cumprimentar outras pessoas em inglês, dizendo meu nome, origem e como estou
          me sentindo.
        </span>
        <FlexRow columnGap={6}>
          {range(1, 6, 1).map((number) => (
            <RateSymbol
              key={`feeling-${number}`}
              onClick={() => setFeelingCapableScore(number)}
              isDisabled={isSubmitting}
              isSelected={number === feelingCapableScore}
              variant={[5, 4].includes(number) ? "#00786A" : [3, 2].includes(number) ? "#FF9F51" : "#B92A49"}
            >
              {number}
            </RateSymbol>
          ))}
        </FlexRow>
      </FlexRow>
      <FlexRow alignItems="center" justifyContent="space-between">
        <span style={{ fontSize: 12, color: "#4e4e4e", fontWeight: 600 }}>
          Em uma escala de 0 a 10, quão satisfeito você esta com as atividades?
        </span>
        <FlexRow columnGap={6}>
          {range(1, 11, 1).map((number) => (
            <RateSymbol
              key={`content-${number}`}
              onClick={() => setContentSatisfactionScore(number)}
              isDisabled={isSubmitting}
              isSelected={number === contentSatisfactionScore}
              variant={[9, 10].includes(number) ? "#00786A" : [7, 8].includes(number) ? "#FF9F51" : "#B92A49"}
            >
              {number}
            </RateSymbol>
          ))}
        </FlexRow>
      </FlexRow>
    </FlexColumn>
  );
}
